import { Controller } from '@hotwired/stimulus'

const FEEDBACK_TIMEOUT = 2000 // ms

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ['button', 'successFeedback', 'clipboardIcon', 'flashTemplate']
  static values = {
    text: String,
    successText: String
  }

  copy (event) {
    event.preventDefault()

    const clipboard = navigator.clipboard
    if (clipboard?.writeText) {
      clipboard.writeText(this.textValue).then(() => this.afterCopy()).catch(() => this.afterCopy())
    } else {
      this.afterCopy()
    }
  }

  afterCopy () {
    if (this.hasSuccessTextValue && this.hasButtonTarget) {
      this.buttonTarget.textContent = this.successTextValue
    } else if (this.hasSuccessFeedbackTarget && this.hasClipboardIconTarget) {
      this.toggleFeedback()
      setTimeout(() => {
        this.toggleFeedback()
      }, FEEDBACK_TIMEOUT)
    }

    this.showFlash()
    this.dispatch('copied')
  }

  showFlash () {
    if (!this.hasFlashTemplateTarget) return

    const flashes = document.getElementById('flashes')
    if (!flashes) return

    flashes.replaceChildren(this.flashTemplateTarget.content.cloneNode(true))
  }

  toggleFeedback () {
    this.clipboardIconTarget.toggleAttribute('hidden')
    this.successFeedbackTarget.toggleAttribute('hidden')
  }
}
